import React, { Component } from 'react';
import DashboardHomeView from './DashboardHomeView';
import { url } from '../../../Server/url/GlobalUrl';

class DashboardHomeComponent extends Component {
    state = {
        applied_counts : '',
        posted_counts : '',
    }
    componentDidMount() {
        let auth = localStorage.getItem("token")
        fetch((url + "/jobs/dashboard-counts/"), {
                method: 'GET',
                headers: {
                   'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + auth,
                },
                })
              .then(res => res.json())
              .then(
		        (result_count) => {
		            console.log('result_count',result_count)
		            this.setState({
		                'applied_counts' : result_count.applied_jobs_count,
		                'jobs_posted_count' : result_count.jobs_posted_count,
		            })
		        })

		        }
    render() {
        return <DashboardHomeView
            applied_counts = {this.state.applied_counts}
            jobs_posted_count = {this.state.jobs_posted_count}
        />
    }
}

export default DashboardHomeComponent;